/**
 * Authentication Service
 *
 * REFACTORED: Now uses platformClient from platform module
 * - Follows DEC-008 module-based API client pattern
 * - Uses platformClient instead of god API client
 *
 * Migration: P0 Fix #1 (Module API Clients)
 */

import { platformClient } from '@/modules/platform/api/platformClient';
import type { LoginCredentials, User } from '@/types/auth';

export const authService = {
  login: async (credentials: LoginCredentials): Promise<User> => {
    return await platformClient.login(credentials);
  },

  getCurrentUser: async (): Promise<User> => {
    return await platformClient.getCurrentUser();
  },

  changePassword: async (oldPassword: string, newPassword: string): Promise<void> => {
    return await platformClient.changePassword(oldPassword, newPassword);
  },

  logout: async (): Promise<void> => {
    return await platformClient.logout();
  },
};
